export default __webpack_public_path__ + "3aece73529947f92b8afc5cc4f541806.ttf";